import React from "react";
import {
  DeleteButton,
  EditButton,
  TopToolbar,
  usePermissions,
} from "react-admin";
import { ROLES } from "../constants";



function ShowActionsPermission({ basePath, data, resource }) {
  const { permissions } = usePermissions();

  return (
    <TopToolbar>
      {permissions?.includes(ROLES.SUPER_ADMIN) &&
        <><EditButton basePath={basePath} record={data} />
          <DeleteButton basePath={basePath} record={data} mutationMode="pessimistic" resource={resource}
            undoable={false} />
        </>
      }
    </TopToolbar>
  );
}

export default ShowActionsPermission;
